module.exports = __webpack_public_path__ + "static/wimbledon-03-8f1883b893afee1c23ec8a8fb2c85c92.png";